{
  "$schema": "./skinning_variables.schema.json",
  "### This JSON overrides some style properties for the high contrast mode; it will use as less colors as possible. The operating systems forced-colors will do the rest": "",
  "_clickareaBgHover": "transparent",
  "primaryColor": "$igColorBlack",
  "secondaryColor": "$igColorBlack",
  "accentColor": "$igColorWhite",
  "highContrastBorder": "1px solid var(--ig-color-black)",
  "highContrastBorderWidth": "1px",
  "highContrastBorderStyle": "solid",
  "highContrastBorderColor": "var(--ig-color-black)",
  "dimmerColor": "$igColorWhite",
  "igColorOverlayAlertDimmer": "$dimmerColor",
  "igBoxShadowColor": "transparent",
  "igBoxShadowBlur": "0px",
  "igBoxShadow": "0 0 0 1px var(--ig-color-black)",
  "linkColor": "revert",
  "igColorFormInputSwitchBackgroundOff": "$igColorWhite",
  "igColorFormInputSwitchHandleOff": "$igColorBlack",
  "igColorFormInputSwitchBackgroundOn": "$igColorWhite",
  "igColorFormInputSwitchHandleOn": "$igColorBlack",
  "igColorFormClickareaForegroundLight": "$igColorBlack",
  "igColorFormClickareaForegroundLightHighlight": "$igColorBlack",
  "igColorStatusGrey": "$igColorBlack",
  "igColorCardLabel": "$igColorBlack",
  "igColorLabelLight": "$igColorBlack"
}
